import React, { useEffect, useState } from 'react';
import { Typography, Button } from 'antd';
import { AppleOutlined } from '@ant-design/icons';
import { appStoreCopyEn } from '../../content/appStore.en';
import styles from './AppStore.module.css';

const { Title, Paragraph } = Typography;

// App Store URL - set VITE_APP_STORE_APP_ID or VITE_APP_STORE_URL in env to override
const APP_STORE_APP_ID = import.meta.env.VITE_APP_STORE_APP_ID || '6757135655';
const APP_STORE_URL =
  import.meta.env.VITE_APP_STORE_URL || `https://apps.apple.com/app/id${APP_STORE_APP_ID}`;

const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

const AppStore: React.FC = () => {
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (isIOS()) {
      setRedirecting(true);
      window.location.href = APP_STORE_URL;
    }
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.icon}>
          <img
            src="/images/portcierge-icon.webp"
            alt="Portcierge"
            className={styles.iconImage}
          />
        </div>
        <Title className={styles.title}>{appStoreCopyEn.title}</Title>
        <Paragraph className={styles.lead}>{appStoreCopyEn.lead}</Paragraph>
        {redirecting ? (
          <Paragraph className={styles.redirecting}>{appStoreCopyEn.redirecting}</Paragraph>
        ) : (
          <>
            <Paragraph className={styles.hint}>{appStoreCopyEn.notOnIos}</Paragraph>
            <Button
              type="primary"
              size="large"
              icon={<AppleOutlined />}
              className={styles.cta}
              href={APP_STORE_URL}
            >
              {appStoreCopyEn.cta}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default AppStore;
